import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { addToChainBefore, Handler } from "@insite/client-framework/HandlerCreator";
import { chain , DispatchCompleteLoadProduct } from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import setShowDiscontinuedProductToast from "@tLinc/Handlers/SetShowDiscontinuedProductToast";

type Parameter = {
    path: string;
    styledOption?: string;
};
type Props = {
    product?: ProductModel;
    productInfosById?: SafeDictionary<ProductInfo>;
    variantChildren?: ProductModel[];
    variantChildrenProductInfos?: ProductInfo[];
    variantSelection?: SafeDictionary<string>;
    pricingLoaded?: true;
    inventoryLoaded?: true;
};

type HandlerType = Handler<Parameter, Props>;

export const FindDiscontinuedProductsForToast: HandlerType = props => {
    let discontinuedProduct = "";

    
    if (props?.product && props?.product?.properties?.replacementMessage) {
        discontinuedProduct = props.product.properties.replacementMessage;
    }
    if (discontinuedProduct !== "") {
        props.dispatch(
            setShowDiscontinuedProductToast({
                discontinuedProductToast: { isShowToast: true, toastMessage: discontinuedProduct },
            }),
        );
    }

    props.product;
};

addToChainBefore(chain, DispatchCompleteLoadProduct, FindDiscontinuedProductsForToast);